<template>
	<div class="main">
		<div class="scdiv">
			<input class="city" type="text" placeholder="选择城市" v-model="citytext" readonly @click="selstat=0;suggestiondata=[];" />
			<input class="address" type="text" placeholder=" 您要去哪？" v-model="address" v-if="selstat==1" />
			<!-- <button
        v-if="selstat==1"
        @click="select_address(address)"
      >确定</button> -->
		</div>
		<div class="dizhi" v-if="selstat==1">
			<div class="item" v-for="item,key in suggestiondata" v-if="item.district" @click="select_address(item.name,item.location)">
				<div class="add1">{{item.name}}</div>
				<div class="add2">{{item.province}}{{item.city}}{{item.district}}</div>
			</div>
		</div>
		<div class="citylist" v-if="selstat==0 && this.isloading==0">
			<div class="zitem" v-for="piny,pk in citydata">
				<div class="zi">{{pk}}</div>
				<div class="cityx">
					<div class="items" v-for="city,ck in piny">
						<div :class="['ct',city.open?'up':'']" @click="openxj(pk,ck)">{{city.name}}</div>
						<div class="xj" v-if="city.open">
							<div class="dm" v-for="itm,ik in city.items" @click="select_city(city.name,itm)">{{itm}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Addr",
		props: ["discount"], //是否城内约车
		data() {
			return {
				city: "",
				county: "",
				address: "",
				suggestiondata: [],
				selstat: 0,
				isloading: 0,
				citydata: {
					A: [{
						name: "成都市",
						open: 0,
						items: ["成华区"]
					}]
				}
			};
		},
		computed: {
			citytext: function() {
				return this.county; //this.city
			}
		},
		created() {},
		mounted() {
			this.getlinelist();
		},
		watch: {
			address: function() {
				this.suggestion_addr(this.city, this.address);
			}
		},
		methods: {
			getlinelist(city = "", area = "") {
				this.selstat = 0;
				this.city = "";
				this.county = "";
				this.address = "";
				this.suggestiondata = [];
				this.isloading = 1;
				// this.$dialog.loading.open("正在为您加载线路信息...");
				this.$ajax({
						method: "post",
						url: "line/getlinelistm",
						data: {
							start_city: city,
							start_area: area,
							incity: this.discount
						}
					})
					.then(response => {
						// this.$dialog.loading.close();
						this.isloading = 0;
						if (response.data.errno == 0) {
							this.citydata = response.data.data.line;
						} else {
							console.log(response.data.errmsg);
						}
					})
					.catch(function(err) {
						console.log(err);
						console.log("路线查找出错啦！");
					});
			},
			openxj(pk, ck) {
				this.citydata[pk][ck].open = this.citydata[pk][ck].open == 1 ? 0 : 1;
			},
			select_city(city, county) {
				this.city = city;
				this.county = county;
				this.selstat = 1;
				this.suggestion_addr(city, county);
			},
			suggestion_addr(city, address) {
				this.$ajax({
						method: "post",
						url: "line/baiduSuggestion",
						data: {
							city: city,
							key: address
						}
					})
					.then(response => {
						if (response.data.errno == 0) {
							// console.log(response.data.data);
							this.suggestiondata = response.data.data;
						}
					})
					.catch(function(err) {
						console.log("查询地点出错");
					});
			},
			select_address(addr, location) {
				if (addr == "") {
					return;
				}
				// console.log(addr);
				this.$emit("selectChange", {
					city: this.city,
					county: this.county,
					address: addr,
					location: location
				});
			}
		},
		components: {}
	};
</script>

<style scoped lang="css">
	.main {
		background-color: #f5f5f7;
	}

	.scdiv {
		width: 100%;
		padding-left: 0.2rem;
		padding-right: 0.2rem;
		background-color: #fff;
		padding-top: 0.2rem;
		position: fixed;
		left: 0px;
		top: 0px;
		height: 0.9rem;
		box-shadow: 0px 0px 2px 0px #ccc;
		font-size: 0.3rem;
	}

	.scdiv input {
		border: 0px;
		height: 0.5rem;
		display: inline-block;
		color: #424242;
	}

	.scdiv button {
		display: inline-block;
		border: 0px;
		border-left: 1px solid #f5f5f7;
		width: 1rem;
		height: 0.5rem;
		position: absolute;
		right: 0.2rem;
		top: 0.2rem;
		color: #0562b1;
		line-height: 0.5rem;
		text-align: center;
	}

	.scdiv .city {
		width: 25%;
		border-right: 1px solid #f5f5f7;
		background-image: url("../assets/images/ic_down.png");
		background-position: right 0.2rem top 0.15rem;
		background-repeat: no-repeat;
		background-size: 0.2rem 0.2rem;
		padding-right: 6%;
		text-align: center;
	}

	.scdiv .address {
		width: 60%;
		padding-left: 0.2rem;
	}

	.citylist {
		width: 100%;
		border-top: 5px solid #fff;
		margin-top: 0.8rem;
	}

	.citylist .zitem {
		width: 100%;
	}

	.citylist .zitem .zi {
		background-color: #f5f5f7;
		height: 0.5rem;
		line-height: 0.5rem;
		padding-left: 0.3rem;
		color: #828387;
	}

	.citylist .zitem .cityx {
		background-color: #fff;
	}

	.cityx .items {
		border-bottom: 1px solid #f5f5f7;
		padding-left: 0.3rem;
		color: #424242;
		font-size: 0.3rem;
		clear: both;
	}

	.cityx .items .ct {
		line-height: 0.8rem;
		background-image: url("../assets/images/ic_down.png");
		background-position: right 0.3rem top 0.2rem;
		background-repeat: no-repeat;
		background-size: 0.3rem 0.3rem;
	}

	.cityx .items .down {
		background-image: url("../assets/images/ic_down.png");
		background-position: right 0.3rem top 0.2rem;
		background-repeat: no-repeat;
		background-size: 0.3rem 0.3rem;
	}

	.cityx .items .up {
		background-image: url("../assets/images/ic_up.png");
		background-position: right 0.3rem top 0.2rem;
		background-repeat: no-repeat;
		background-size: 0.3rem 0.3rem;
	}

	.cityx .items .xj {
		line-height: 0.8rem;
	}

	.cityx .items .xj .dm {
		background-color: #fafafc;
		height: 0.6rem;
		line-height: 0.6rem;
		padding-left: 0.35rem;
		padding-right: 0.35rem;
		border-radius: 2px;
		display: inline-block;
		font-size: 0.25rem;
		margin-right: 0.2rem;
	}

	.cityx .items .xj .dm:active {
		background-color: #f1f1f1;
	}

	.dizhi {
		width: 100%;
		border-top: 5px solid #fff;
		margin-top: 0.8rem;
		background-color: #f5f5f7;
	}

	.dizhi .item {
		width: 100%;
		height: 1.4rem;
		padding-left: 1rem;
		padding-top: 0.2rem;
		padding-bottom: 0.2rem;
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		background-color: #fff;
		margin-bottom: 1px;
		background-image: url("../assets/images/ic_addls.png");
		background-position: left 0.3rem top 0.4rem;
		background-repeat: no-repeat;
		background-size: 0.4rem 0.4rem;
	}

	.dizhi .item:active {
		background-color: #fcfcfc;
	}

	.dizhi .item .add1 {
		height: 0.5rem;
		line-height: 0.5rem;
		color: #3f3f3f;
		font-size: 0.3rem;
	}

	.dizhi .item .add2 {
		height: 0.5rem;
		line-height: 0.5rem;
		color: #a4a4b1;
		font-size: 0.2rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/Addr.vue